import { render, staticRenderFns } from "./LgsRequirementPurchase.vue?vue&type=template&id=2166fd5e&"
import script from "./LgsRequirementPurchase.vue?vue&type=script&lang=js&"
export * from "./LgsRequirementPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports